import { Component, OnInit } from '@angular/core';
import { FormService } from '../../services/form.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Step, ExecutionResult, Question, Respondent } from '../../services/generated/models';
import { ApiClientService } from 'services/generated/index';
import * as _ from 'lodash';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {

  mailSent = false;
  email = '';

  constructor(
    private serviceClient: ApiClientService,
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService) { }

  ngOnInit() {
    const that = this;
    if (that.formService.currentForm == null) {
      const guid = that.route.snapshot.paramMap.get('guid');
      const template = +that.route.snapshot.paramMap.get('template');
      const frame = +that.route.snapshot.paramMap.get('frame');
      that.router.navigate([`/form/${guid}/1/${template}/${frame}`]);
    }
  }

  public getDecisionName(step: Step, execResult: ExecutionResult): string {
    const that = this;
    let result = '';

    step.Decisions.forEach(decision => {
      if (decision.Id === execResult.DecisionId) {
        result = decision.Name;
      }
    });

    return result;
  }

  public getDecisionResult(execResult: ExecutionResult): string {
    const that = this;
    let result = '';
    const allOutputData = that.formService.getAllOutputData();
    execResult.HitConclusions.forEach(hc => {
      if (hc.BusinessDataId === +execResult.ViewModelFinalConclusionBusinessDataIds) {
        result = hc.Value;
      }
    });

    const outputdata = allOutputData.find(data => data.BusinessDataId === +execResult.ViewModelFinalConclusionBusinessDataIds);
    if (outputdata != null) {
      if (outputdata.Unit === '%') {
        result = '' + (+result * 100);
      }
      if (outputdata.Unit === '€') {
        result = outputdata.Unit + ' ' + result;
      } else {
        result += ' ' + outputdata.Unit
      }
    }
    return result;
  }

  public sendRespond(): void {
    const that = this;
    const respondForm = that.formService.getRespond();

    const respondent = new Respondent();
    respondent.Form = respondForm;
    respondent.Email = that.email;
    that.serviceClient.FormApi_SendRespond(respondent)
      .subscribe(response => {
      });

    that.mailSent = true;
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/summary/summary.component.ts